<template>
  <div v-if="currentSong">
    <div class="mini-player" :class="[!isTiny ? 'show' : 'hide']">
      <div class="expanded" title="收起" @click="isTiny = true">
        <span class="iconfont icon-zuixiaohua"></span>
      </div>
      <div class="info">
        <div class="name">{{ currentSong.name }}</div>
        <div class="author">{{ currentSong.author }}</div>
        <div class="progress" @click="changeProgress">
          <span class="song-current-time">{{currentTime|songTime}}</span>
          <div class="rate" :style="{ width: percent + '%' }"></div>
          <span class="song-duration">{{duration|songTime}}</span>
        </div>
      </div>
      <div class="play">
        <div
          class="lyric"
          v-html="currentSong.lrc ? currentLine : '暂无歌词'"
        ></div>
        <div class="play-btn">
          <div
            class="iconfont icon-play--filled--alt"
            v-if="paused"
            @click="play()"
          ></div>
          <div
            class="iconfont icon-pause--filled"
            v-else
            @click="pause()"
          ></div>
        </div>
        <div class="volume">
          <div
            class="iconfont icon-volume--mute--filled"
            @click="setVolume(0)"
          ></div>
          <div class="volume-ctrl" @click="changeVolume">
            <div class="rate" :style="{ width: volume + '%' }"></div>
          </div>
          <div
            class="iconfont icon-volume--down--filled"
            @click="setVolume(1)"
          ></div>
        </div>
      </div>
    </div>
    <div class="tiny-player" :class="[isTiny ? 'show' : 'hide']">
      <div class="container">
        <div class="content">
          <div class="name">
            {{
              [currentSong.name, currentSong.author].filter(Boolean).join('-')
            }}
          </div>
          <div class="lyric">{{ currentLine }}</div>
        </div>
        <div class="play-btn">
          <div
            class="iconfont icon-play--filled--alt"
            v-if="paused"
            @click="play()"
          ></div>
          <div
            class="iconfont icon-pause--filled"
            v-else
            @click="pause()"
          ></div>
        </div>
        <div class="open-large" title="展开" @click="isTiny = false">
          <span class="iconfont icon-max-mac"></span>
        </div>
      </div>
      <div class="progress" @click="changeProgress">
        <div class="rate" :style="{ width: percent + '%' }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { LrcParser } from '@/utils/parseLrc';
let isPreloadPlay = false;

export default {
  data() {
    let audio = new Audio();
    this.lrcParser = new LrcParser();

    this.audio = audio;
    return {
      percent: 0,
      volume: 0,
      paused: false,
      duration: 0,
      currentTime: 0,
      playend: false,
      currentLine: '',
      isTiny: false,
    };
  },
  computed: {
    ...mapState(['currentSong']),
  },
  filters: {
    songTime(value){
      let min = Math.floor(value/60)
      let sec = Math.floor(value - (min*60))
      return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`
    }
  },
  watch: {
    currentSong() {
      let { url, lrc } = this.currentSong;
      this.currentTime = 0
      this.play(url);
      if (lrc) {
        this.lrcParser.load(lrc);
      } else {
        this.currentLine = '';
      }
    },
  },
  created() {
    this.audio.onplaying = (e) => {
      this.paused = false;
      this.playend = false;
    };
    this.audio.ondurationchange = () => {
      this.duration = this.audio.duration;
    };
    this.audio.ontimeupdate = (e) => {
      this.currentTime = this.audio.currentTime
      this.percent = (this.audio.currentTime / this.audio.duration) * 100;
      if (this.currentSong.lrc) {
        let line = this.lrcParser.get(this.audio.currentTime + 0.3);
        if (line.trim()) {
          this.currentLine = line;
        }
      }
    };
    this.audio.onpause = () => {
      this.paused = true;
    };
    this.audio.onended = () => {
      this.playend = true;
    };
    this.volume = (this.audio.volume / 1) * 100;
  },
  methods: {
    changeProgress(e) {
      if (this.audio.seekable) {
        this.percent = this.getPointerRate(e);
        this.audio.currentTime = (this.percent / 100) * this.duration;
      }
    },
    changeVolume(e) {
      this.volume = this.getPointerRate(e);
      this.setVolume(this.volume / 100);
    },
    getPointerRate(e) {
      let { x, width } = e.target.getBoundingClientRect();
      let diff = e.clientX - x;
      return (diff / width) * 100;
    },
    play(url) {
      if (url && url != this.audio.src) {
        this.audio.src = url;
        this.duration = 0;
      }
      if (this.playend) {
        this.audio.currentTime = 0;
      }
      this.audio.play();
    },
    pause() {
      this.audio.pause();
    },
    setVolume(rate) {
      this.audio.volume = rate;
      this.volume = rate * 100;
    },
    prePlay() {
      if (isPreloadPlay) return;
      let audio = new Audio();
      audio.play();
      isPreloadPlay = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.mini-player {
  display: flex;
  flex-direction: column;
  width: 350px;
  position: fixed;
  z-index: 1;
  top: -600px;
  left: -600px;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.2);
  user-select: none;
  &.show {
    top: 10px;
    left: 10px;
    opacity: 1;
    transform: scale(1);
    transform-origin: 0 0;
    transition: all ease-out 0.2s;
  }
  &.hide {
    top: 10px;
    left: 10px;
    opacity: 0;
    pointer-events: none;
    transform: scale(0);
    transition: all ease-in 0.2s;
  }

  .info {
    display: flex;
    flex-direction: column;
    font-weight: lighter;
    font-size: 16px;
    padding: 20px 50px;
    position: relative;
    border-bottom: 1px solid rgba(246, 246, 246, 0.5);
    .name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .author {
      font-size: 14px;
      margin-top: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .progress {
      position: absolute;
      height: 4px;
      bottom: -2px;
      width: 100%;
      left: 0;
      cursor: pointer;
      .rate {
        position: absolute;
        top: 1px;
        left: 0;
        height: 2px;
        background-color: #99ec73;
      }
      .song-current-time {
        position: absolute;
        left: 4px;
        top: 4px;
        font-size: 12px;
        color: #ccc;
      }
      .song-duration {
        position: absolute;
        right: 4px;
        top: 4px;
        font-size: 12px;
        color: #ccc;
      }
    }
  }

  .play {
    .lyric {
      height: 6em;
      padding: 10px 20px;
      text-align: center;
      font-size: 12px;
      font-weight: lighter;
      color: #3b3b3b;
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid rgba(246, 246, 246, 0.5);
      overflow: auto;
    }
    .play-btn {
      padding: 20px 0;
      .iconfont {
        display: inline-block;
        width: 60px;
        text-align: center;
        font-size: 40px;
        cursor: pointer;
        &:hover {
          color: #99ec73;
        }
      }
    }
    .volume {
      padding-bottom: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      .iconfont {
        width: 60px;
        text-align: center;
        cursor: pointer;
        &:hover {
          color: #99ec73;
        }
      }
      .volume-ctrl {
        width: 160px;
        height: 4px;
        position: relative;
        cursor: pointer;
        &::before {
          content: '';
          position: absolute;
          z-index: 1;
          left: 0;
          height: 2px;
          top: 1px;
          height: 2px;
          width: 100%;
          background-color: #f7f7f7;
        }
        .rate {
          height: 2px;
          background-color: #99ec73;
          width: 20%;
          position: absolute;
          z-index: 2;
          top: 1px;
          left: 0;
        }
      }
    }
  }
}
.tiny-player {
  position: fixed;
  z-index: 1;
  background-color: #fff;
  top: 10px;
  left: 10px;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  font-size: 12px;
  overflow: hidden;
  transform-origin: 0 0;
  &.show {
    top: 10px;
    left: 10px;
    opacity: 1;
    transform: scale(1);
    transition: all ease-out 0.2s;
    transition-delay: 0.2s;
  }
  &.hide {
    top: 10px;
    left: 10px;
    opacity: 0;
    transform: scale(0);
    pointer-events: none;
    transition: all ease-in 0.2s;
  }

  .progress {
    position: absolute;
    height: 4px;
    bottom: 0;
    width: 100%;
    left: 0;
    cursor: pointer;
    .rate {
      position: absolute;
      top: 1px;
      left: 0;
      height: 4px;
      background-color: #99ec73;
    }
  }
  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    .play-btn {
      width: 30px;
      height: 30px;
      max-width: 30px;
      min-width: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .iconfont {
        &:hover {
          color: #99ec73;
        }
      }
    }
    .content {
      flex: auto;
      display: flex;
      flex-direction: column;
      width: 140px;
      text-align: left;
      .name {
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .lyric {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: lighter;
      }
    }
  }
}
.expanded {
  position: absolute;
  top: 2px;
  right: 10px;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1;

  &:hover {
    color: #99ec73;
  }
}
.open-large {
  cursor: pointer;
  &:hover {
    color: #99ec73;
  }
}

@media screen and (max-width: 800px) {
  .tiny-player {
    padding: 0 10px;
    width: calc(100% - 20px);
    &.show {
      top: 4px;
    }
  }
}
</style>